
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affordable-self-storage-services",
      function () {
        return require("private-next-pages/affordable-self-storage-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affordable-self-storage-services"])
      });
    }
  